import clsx from "clsx";
import { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { HeroDescription, HeroTitle } from "components/atoms/Text";
import { connect } from "react-redux";
import { updateIdMenu } from "state/proxy.action";

const Hero = ({ refs, idMenu }) => {
    useEffect(() => {
        console.log(idMenu);
    }, []);
    return (
        <Fragment>
            <header ref={refs} className={clsx(
                "w-full max-w-[1440px] mx-auto relative top-8",
                "flex flex-col tablet:flex-row desktop:flex-row justify-between",
                "px-6 tablet:pl-8 desktop:pl-[120px]",
                "tablet:pr-2 desktop:pr-12 tablet:pb-[66px] pb-20 desktop:pb-[70px] overflow-hidden"
            )}>
                <img src='/images/homepage/hero/blockpath.svg' className='phone:hidden absolute tablet:bottom-[5px] -bottom-10 desktop:bottom-[-24px] -left-[-0.5rem] desktop:left-[-18px] tablet:w-[246px] desktop:w-[280px] desktop:h-[340px]' width="324px" height="290px" alt="path" />
                <div className="w-full tablet:max-w-[386px] desktop:w-[481px] tablet:mt-5 desktop:mt-[10px] pt-10 tablet:pt-[90px] desktop:pt-[135px]">
                    <HeroTitle classNames="tablet:!text-heading-1 tablet:!leading-[75.6px]">Buy Proxy and SOCKS 5</HeroTitle>
                    <HeroDescription classNames="md:max-w-[430px] tablet:-mt-[12px] phone:mt-0 tablet:leading-[27.2px] desktop:!leading-[30.2px] phone:text-[16px]">
                        Buy anonymous proxy (shared, dedicated or residential) starting at just <span className="font-bold text-primary-main">$0.7</span>
                    </HeroDescription>
                    <div className="w-full flex flex-col md:flex-row md:items-center tablet:mt-6 md:space-x-6 space-y-4 md:space-y-0 phone:mt-6 mt-[40px]">
                        <Link to="/auth/signin" className="">
                            <button className="relative z-20 leading-[19.83px] py-[18px] h-[56px] flex items-center justify-center w-full md:w-[170px] font-semibold rounded-lg bg-primary-main hover:bg-primary-hover md:text-md text-md text-basier-circle-semibold text-neutral-10">Buy Proxy</button>
                        </Link>
                        <Link to="#" className="relative z-20">
                            <button className="py-[18px] leading-[19.83px] w-full h-[56px] flex items-center justify-center md:w-[170px] font-semibold rounded-lg text-primary-main md:text-md text-md text-basier-circle-semibold bg-primary-surface">Buy VPN</button>
                        </Link>
                    </div>
                </div>
                <div className="w-full tablet:max-w-[581px] max-w-[777px] md:pl-[14px] tablet:mt-5 desktop:mt-[36px]">
                    <img src="/images/homepage/proxy-hero.svg" width="777px" height="567px" alt="proxy-hero" />
                </div>
            </header>
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        idMenu: state.proxy.idMenu
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenu: (id) => dispatch(updateIdMenu(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Hero);